import styled from "styled-components";

// 보조 네비게이션 바
const SubNavigation = styled.ul`
    display: flex;
    border-bottom: 2px solid black;
    margin-bottom: 1rem;
`
export default SubNavigation